export interface NodeVersions {
    readonly targetVersions: readonly string[];
    readonly testedVersions: readonly string[];
    readonly currentReleases: readonly string[];
}
